<h-call-to-action
    class="h-call-to-action"
    [appearance]="'secondary'"
    [loading]="(registerYourInterestFacade.loading$ | async) === true"
    [size]="'medium'"
    [dataTestId]="'Register Your Interest'"
    (pressed)="openRegisterYourInterest()"
    i18n="@@hermes-cta-product-page.register-interest">
    Register your interest
</h-call-to-action>
